import { CapoPlugin } from "/home/runner/work/cv/cv/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];